import "vanilla-cookieconsent/dist/cookieconsent.css"
import * as CookieConsent from "vanilla-cookieconsent"

export function initCookieConsent() {
  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "bottom right",
      },
      preferencesModal: {
        layout: "box",
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {},
    },

    language: {
      default: "fr",
      translations: {
        fr: {
          consentModal: {
            title: "Nous utilisons des cookies",
            description:
              "Nous utilisons des cookies essentiels au fonctionnement du site et, avec votre accord, des cookies d'analyse pour améliorer votre expérience.",
            acceptAllBtn: "Tout accepter",
            acceptNecessaryBtn: "Refuser",
            showPreferencesBtn: "Personnaliser",
          },
          preferencesModal: {
            title: "Préférences de cookies",
            acceptAllBtn: "Tout accepter",
            acceptNecessaryBtn: "Refuser tout",
            savePreferencesBtn: "Enregistrer",
            sections: [
              {
                title: "Cookies nécessaires",
                description:
                  "Ces cookies sont indispensables au fonctionnement du site (session, sécurité CSRF). Ils ne peuvent pas être désactivés.",
                linkedCategory: "necessary",
              },
              {
                title: "Cookies d'analyse",
                description:
                  "Ces cookies nous aident à comprendre comment vous utilisez le site afin de l'améliorer. Vos données restent hébergées en Europe.",
                linkedCategory: "analytics",
              },
            ],
          },
        },
      },
    },

    onConsent: async () => {
      if (CookieConsent.acceptedCategory("analytics")) {
        const { enableAnalyticsCookies } = await import("./posthog")
        enableAnalyticsCookies()
      }
    },

    onChange: async () => {
      const { enableAnalyticsCookies, disableAnalyticsCookies } = await import("./posthog")
      if (CookieConsent.acceptedCategory("analytics")) {
        enableAnalyticsCookies()
      } else {
        disableAnalyticsCookies()
      }
    },
  })
}
